import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IPaginatorModel } from '@types-custom/models/ui/paginator-model';

@Component({
  selector: 'paginator',
  templateUrl: './sit-paginator.component.html',
  styleUrls: ['./sit-paginator.component.scss'],
})
export class SitPaginatorComponent {

  @Input() pageInfo: IPaginatorModel;
  @Output() pageChange = new EventEmitter<IPaginatorModel>();

  Icon = Icon;

  pageSizesList = [1, 2, 10, 20, 25, 30, 50];
  pageSizeSelector = 10;

  get lastPage(): number {
    const { totalCount, pageSize } = this.pageInfo;
    return Math.ceil((totalCount ?? 1) / pageSize) - 1;
  }

  get startingIndex() {
    const { page, pageSize } = this.pageInfo;
    const index = (page * pageSize) + 1;
    return index;
  }

  get endingIdex() {
    const { page, pageSize, totalCount } = this.pageInfo;
    const index = ((page + 1) * pageSize);
    return Math.min(index, totalCount ?? Number.MAX_VALUE);
  }

  setPage(newPage: number): void {
    if (newPage < 0 || newPage > this.lastPage || newPage === this.pageInfo.page) return;
    this.pageChange.emit({
      page: newPage,
      pageSize: this.pageSizeSelector,
    });
  }

  handleSizeSelection(newPageSize: number) {
    if (newPageSize < 0 || !this.pageSizesList.includes(newPageSize)) return;
    this.pageChange.emit({
      page: 0,
      pageSize: this.pageSizeSelector,
    });
  }

  setFirstPage = () => this.setPage(0);
  setLastPage = () => this.setPage(this.lastPage);
  setNextPage = () => this.setPage(this.pageInfo.page + 1);
  setPrevPage = () => this.setPage(this.pageInfo.page - 1);
}
